import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  width: 100vw;
  min-height: 85vh;
  position: relative;
  .header {
    width: 80%;
    margin: 1rem auto;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
    padding: 1rem;
    .description {
      .teams {
        font-weight: 700;
      }
    }
    .box-score {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .score-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        .score {
          display: flex;
          justify-content: space-between;
          p {
            font-size: 20px;
            margin: auto 1rem;
            font-weight: 700;
          }
        }
      }
    }
  }
  .content {
    width: 80%;
    margin: 0 auto;
    display: none;
    flex-direction: column;
    box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
    padding: 1rem;
    overflow: scroll;
    &.active {
      display: flex;
    }
    .content-item {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    .container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 10px;
      position: relative;
    }
    .team-container {
      width: fit-content;
      margin: auto;
      background: #fff;
      min-height: 85vh;
      padding-bottom: 1rem;
      .team-header,
      .player-container {
        display: flex;
        width: 100%;
        margin: 0 auto;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #e5e7eb;
        p {
          flex-basis: 5%;
          text-align: center;
          font-size: 13px;
          &.name {
            flex-basis: 25%;
            text-align: left;
          }
        }
      }
      .team {
        width: fit-content;
      }
      .team-header {
        font-weight: 700;
        p {
          padding: 0 0.5rem;
        }
      }
      .player-container {
        border-bottom: 1px solid rgb(235 235 235 / 1);
        width: 100%;
        p {
          padding: 0 0.5rem;
        }
        img {
          width: 25px;
        }
        button {
          width: 25px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 17px;
          }
        }
      }
    }
  }
  .chart-options_container {
    width: 80%;
    margin: 0 auto;
    display: flex;
    border-bottom: 1px solid lightGray;
    .chart-option {
      width: 100%;
      button {
        width: 100%;
        height: 50px;
        background: white;
        box-shadow: none;
        border: none;
        cursor: pointer;
        color: #000;
        font-size: 18px;
        font-weight: 700;
      }
      &.active {
        border-top: 5px solid orange;
        border-left: 1px solid lightGray;
        border-right: 1px solid lightGray;
      }
    }
  }
  @media only screen and (min-width: 867px) {
    .header,
    .content,
    .chart-options_container {
      width: 90%;
    }
    .content {
      overflow: auto;
      .team-container {
        width: 100%;
      }
    }
    .header .box-score .score-container .score p {
      font-size: 25px;
    }
  }
`;
